import React, { Component } from 'react';
export default class Servicess extends Component {
    render() {
      return (
        <React.Fragment>
        {/*generated code*/}
                <section id="services">
                <div className="overlay" />
                <div className="row section-intro">
                <div className="col-twelve">
                    <h5>Services</h5>
                    <h1>What Can I Do For You?</h1>
                    <aside className="pull-quote">
                    <blockquote><p className="lead">Helping is a medicine known to some. People think it is a fortune for one to recive kindness from someone. I believe helping is a Drug that work both ways. The seeker gets the help and the Helper gets a Sweet feeling. Helping and providing services to people strengthens my mood and fill me up with positive energy while reciving credits and Appraisals for the same adds up the charge.</p></blockquote>
                    </aside>
                </div>
                </div> {/* /section-intro */}
            </section> {/* /services */}
        </React.Fragment>
      );
    }
  }